import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { CalendarItem, DateRange } from './calendar.model';
import { SpinnerService } from '../../services/spinner-handler/spinner-handler.service';
import { ResizeEvent } from 'angular-resizable-element';
declare var $: any;

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html'
})
export class CalendarComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() isEditable: boolean = true;
  @Input() isDragAndDrop: boolean = true;
  @Input() showOnlyMonthView: boolean = false;
  @Input() set items(newItems: Array<CalendarItem>) {
    this._items = newItems;
    if (this.$calendar != undefined) {
      this.$calendar.removeEvents();
      this.$calendar.renderEvents(this._items, true);
    }
  }
  get items(): Array<CalendarItem> {
    return this._items;
  }

  @Output() onItemClick = new EventEmitter<any>();
  @Output() onDayClick = new EventEmitter<any>();
  @Output() onPrevClick = new EventEmitter<DateRange>();
  @Output() onNextClick = new EventEmitter<DateRange>();
  @Output() onTodayClick = new EventEmitter<DateRange>();
  @Output() onDateNavClick = new EventEmitter<DateRange>();

  public currentDateRange: DateRange;

  private _items = new Array<CalendarItem>();
  private selectedEvent: any;
  private $calendar: any;
  private calendarOptions: any = this.getInitOptions();

  @ViewChild('fullcalendar') fullcalendar: ElementRef;

  constructor() { }

  ngOnInit() {
    this.calendarOptions.editable = this.isEditable;
    this.calendarOptions.droppable = this.isDragAndDrop;
    this.calendarOptions.eventSources = [this._items];
    this.calendarOptions.header = {
      left: 'myPrev,myNext myToday',
      center: 'title',
      right: ''
    };
    if (!this.showOnlyMonthView) {
      this.calendarOptions.header.right = 'month,agendaWeek,agendaDay';
    }

  }

  ngAfterViewInit() {
    let calendarRef = $(this.fullcalendar.nativeElement);
    calendarRef.fullCalendar(this.calendarOptions);
    this.$calendar = calendarRef.fullCalendar('getCalendar');

    this.currentDateRange = this.getCurrentDateRange();
    //this.onDateNavClick.emit(currentDateRange);
  }

  public onMyPrev() {
    $('#calendar').fullCalendar('prev');
    let currentDateRange = this.getCurrentDateRange();
    this.onPrevClick.emit(currentDateRange);
    this.onDateNavClick.emit(currentDateRange);
  }

  public onMyNext() {
    $('#calendar').fullCalendar('next');
    let currentDateRange = this.getCurrentDateRange();
    this.onNextClick.emit(currentDateRange);
    this.onDateNavClick.emit(currentDateRange);
  }

  public onMyToday() {
    $('#calendar').fullCalendar('today');
    let currentDateRange = this.getCurrentDateRange();
    this.onTodayClick.emit(currentDateRange);
    this.onDateNavClick.emit(currentDateRange);
  }

  public getCurrentDateRange(): DateRange {
    let currentView = this.$calendar.getView();
    let currentStart = new Date(currentView.intervalStart._d.setHours(0));
    let currentEndTemp = currentView.intervalEnd._d;
    let currentEnd = new Date(currentEndTemp.getFullYear(), currentEndTemp.getMonth(), 0);
    let dateRange = { start: currentStart, end: currentEnd };

    return dateRange;
  }

  private eventClick(calEvent, jsEvent, view) {
    this.selectedEvent = {
      title: calEvent.title,
      start: calEvent.start,
      url: calEvent.url || ''
    };

    this.onItemClick.emit(calEvent);
  }

  private dayClick(date, jsEvent, view) {
    this.selectedEvent = {
      date: date.format()
    };

    this.onDayClick.emit(this.selectedEvent);
  }

  private onItemRender(info: any, el: any) {
    el.attr('title', info.title);
  }

  private getInitOptions() {
    let options = {
      customButtons: {
        myPrev: {
          click: this.onMyPrev.bind(this),
          icon: ' fas fa-caret-left'
        },
        myNext: {
          click: this.onMyNext.bind(this),
          icon: ' fas fa-caret-right'
        },
        myToday: {
          text: 'dziś',
          click: this.onMyToday.bind(this)
        }
      },
      buttonIcons: { // note the space at the beginning
        prev: ' fas fa-caret-left',
        next: ' fas fa-caret-right'
      },
      buttonText: {
        month: 'miesiąc',
        week: 'tydzień',
        day: 'dzień'
      },
      timeFormat: 'H:mm',
      editable: this.isEditable,
      droppable: this.isDragAndDrop,
      eventClick: this.eventClick.bind(this),
      dayClick: this.dayClick.bind(this),
      eventRender: this.onItemRender.bind(this),
      locale: 'pl',
      eventLimit: 4,
      businessHours: {
        dow: [1, 2, 3, 4, 5], // Monday - Friday

        start: '8:00', // a start time
        end: '16:00', // an end time
      },
      minTime: '06:00:00',
      maxTime: '18:00:00',
      nowIndicator: true,
      handleWindowResize: true,
      aspectRatio: 1.8,
      eventLimitText: 'więcej',
      views: {
        month: {
          locale: 'pl',
          displayEventTime: false
        },
        basic: {
          locale: 'pl'
        },
        agenda: {
          locale: 'pl'
        },
        week: {
          locale: 'pl'
        },
        day: {
          locale: 'pl'
        }
      }
    };

    return options;
  }

  ngOnDestroy() {
    this.$calendar.destroy();
  }

}
